import { Link } from '@inertiajs/react'
import { PanelsTopLeft } from 'lucide-react'

export default function RuntimeProjectLink({ projectId, label }: { projectId?: string | null; label: string }) {
  if (!projectId) return null
  return <Link href={`/dashboard/projects/${projectId}/dashboards`} className="inline-flex h-8 items-center gap-2 whitespace-nowrap rounded-md px-2 text-xs font-medium text-muted-foreground hover:bg-muted hover:text-foreground">
    <PanelsTopLeft className="size-4" />{label}
  </Link>
}
